import React, { useCallback, useMemo } from "react";
import { getTPRMContractsApi } from "../../../services/axios/AuthApis/TPRMApis";
import TPRMResourceTable, { StatusBadge } from "./TPRMResourceTable";
import {
  displayTPRMValue,
  formatTPRMDate,
} from "./tprmPageUtils";

const FILTERS = [
  {
    id: "vendor_id",
    definition: {
      variant: "text",
      label: "Vendor ID",
      placeholder: "Enter exact vendor ID",
    },
  },
  {
    id: "status",
    definition: {
      variant: "select",
      label: "Contract status",
      placeholder: "All statuses",
      options: ["Draft", "Under Review", "Active", "Expired", "Terminated"].map(
        (value) => ({ value, label: value }),
      ),
    },
  },
];

const ContractsPage = () => {
  const fetchPage = useCallback((params) => getTPRMContractsApi(params), []);
  const columns = useMemo(
    () => [
      {
        accessorKey: "contract_id",
        header: "Contract ID",
        size: 165,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        accessorKey: "title",
        header: "Contract title",
        size: 220,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        id: "vendor_id",
        accessorFn: (contract) =>
          contract.vendor_details?.vendor_id ?? contract.vendor,
        header: "Vendor",
        size: 200,
        cell: ({ row }) => (
          <div>
            <div>{displayTPRMValue(row.original.vendor_details?.name)}</div>
            <div className="text-xs text-slate-500">
              {displayTPRMValue(row.original.vendor_details?.vendor_id ?? row.original.vendor)}
            </div>
          </div>
        ),
      },
      {
        accessorKey: "contract_type",
        header: "Contract type",
        size: 190,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        accessorKey: "start_date",
        header: "Start date",
        size: 140,
        cell: ({ getValue }) => formatTPRMDate(getValue()),
      },
      {
        accessorKey: "end_date",
        header: "End date",
        size: 140,
        cell: ({ getValue }) => formatTPRMDate(getValue()),
      },
      {
        accessorKey: "auto_renewal",
        header: "Renewal status",
        size: 135,
        cell: ({ getValue }) => {
          const value = getValue();
          return value === null || value === undefined
            ? "—"
            : value
              ? "Yes"
              : "No";
        },
      },
      {
        accessorKey: "status",
        header: "Contract status",
        size: 155,
        cell: ({ getValue }) => <StatusBadge value={getValue()} />,
      },
    ],
    [],
  );

  return (
    <TPRMResourceTable
      columns={columns}
      description="Review vendor contracts and renewal terms."
      fetchPage={fetchPage}
      filters={FILTERS}
      getRowId={(contract) => contract.contract_id}
      title="Contracts"
    />
  );
};

export default ContractsPage;
